export default {
  homePage: 'Главная',
  tilesAbout: 'О сервисе',
  close: 'Закрыть',
  inn: 'ИНН',
  ogrn: 'ОГРН',
  kpp: 'КПП',
  cancel: 'Отмена',
  confirm: 'Подтвердить',
  clearingCode: 'Код участника клиринга / торгов',
  unicode: 'Юникод',
  fullname: 'Полное наименование',
  fullnameEn: 'Полное наименование (на английском)',
  orgChangeConfirm: 'Подтвердите смену организации',
  orgChangeConfirmText: 'Вы действительно хотите сменить организацию?',
  checkSign: 'Проверить подпись',
  sendAdditionalDocsText: 'Если вам необходимо дослать дополнительные документы, используйте сервис отправки документов в свободной форме',
  sendAdditionalDocsButton: 'Отправить документы',
  backToRegistrationFailedText: 'Не удалось вернуться к регистрации',
  continueRegistrationText: 'Для получения доступа в личный кабинет участника необходимо продолжить регистрацию',
  continueRegistrationButton: 'Продолжить',
  goToNewInterfaceText: 'Вы можете перейти к новому интерфейсу главной страницы',
  goToNewInterfaceButton: 'Новый интерфейс',
}